export const MESSAGE_TO_APPROVER_MAX_LENGTH = 400;
export const MESSAGE_TO_APPROVER_MAX_LENGTH_ERROR_MESSAGE = `Enter ${MESSAGE_TO_APPROVER_MAX_LENGTH} characters or less.`;

export const tooltipCopy = {
  messageToApprover: 'You can leave a note for the flyer approver to reference when they review your flyer.',
};
